import styled from 'styled-components'

export const StyledVolumesQueriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
`
